// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDra6uJqBllkd4UppFxL0Lantsqoi-7MNw",
  authDomain: "jupipotes-9a7bd.firebaseapp.com",
  projectId: "jupipotes-9a7bd",
  storageBucket: "jupipotes-9a7bd.firebasestorage.app",
  messagingSenderId: "970375712094",
  appId: "1:970375712094:web:b65ff5da8dd07ef4add3cf",
  measurementId: "G-JTFDWQZEMG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage, analytics };
export default app;
